// extracted by mini-css-extract-plugin
module.exports = {"fontPrimary":"'Nunito', 'Helvetica Neue', Helvetica, Arial, sans-serif","primary":"rgb(40, 90, 132)","container":"q_S","title":"q_c"};